var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mb-2 mt-3"},[_vm._v("Transactions History")]),_vm._v(" "),_vm._l((_vm.rewardTransactions),function(transaction){return _c('div',[_c('transaction',{attrs:{"transaction":transaction,"source":_vm.source}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }